import Box from '@mui/material/Box';
import { Icon } from 'assets/Icon.js';
import {
  CircularProgress,
  ConfirmModalDescription,
  ConfirmModalTitle,
} from 'components/ui/modals/ConfirmModal/index.js';
import type { FC } from 'react';
import { GenericForm } from 'shared/form/GenericForm/index.js';

import { helpdeskFormItems } from './Helpdesk.form.js';
import type {
  HelpdeskContextContext,
  HelpdeskModalState,
} from './Helpdesk.types.js';

export const getHelpdeskModalIcon = (state: HelpdeskModalState) => {
  switch (state) {
    case 'Opened':
      return <Icon icon="supportSvg" style={{ width: 50 }} />;
    case 'Creating':
      return <Icon icon="uploadSvg" style={{ width: 50 }} />;
    case 'Success':
      return <Icon icon="alertSuccessSvg" />;
    case 'Error':
      return <Icon icon="alertErrorSvg" />;
    default:
      return null;
  }
};

export const HelpdeskModalContent: FC<{
  state: HelpdeskModalState;
  errorMessage?: string;
  onSubmit: (data: HelpdeskContextContext['data']) => void;
}> = ({ state, errorMessage, onSubmit }) => {
  switch (state) {
    case 'Opened':
      return (
        <>
          <ConfirmModalTitle>Helpdesk</ConfirmModalTitle>
          <ConfirmModalDescription>
            <GenericForm items={helpdeskFormItems} submitHandler={onSubmit} />
          </ConfirmModalDescription>
        </>
      );
    case 'Creating':
      return (
        <>
          <CircularProgress />
          <Box mt={2}>
            <ConfirmModalTitle>Sending...</ConfirmModalTitle>
          </Box>
        </>
      );
    case 'Success':
      return (
        <>
          <ConfirmModalTitle>Success</ConfirmModalTitle>
          <ConfirmModalDescription>
            We have created a new ticket in our helpdesk system.
            {' '}
            <br />
            Our support team will reach out as soon as it&apos;s possible.
          </ConfirmModalDescription>
        </>
      );
    case 'Error':
      return (
        <>
          <ConfirmModalTitle>Error</ConfirmModalTitle>
          <ConfirmModalDescription>
            We have some problems with reporting your problem
            {errorMessage && (
              <>
                : &quot;
                {errorMessage}
                &quot;
              </>
            )}
          </ConfirmModalDescription>
        </>
      );
    default:
      return null;
  }
};
